import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { MemoryConfig } from '@timelyapp/integration-cloud-api-spec';

export interface TicConfigDefaultsState {
  isViewingDefaults: boolean;
  defaultMemoryConfig: MemoryConfig | null;
}

const initialState: TicConfigDefaultsState = {
  isViewingDefaults: false,
  defaultMemoryConfig: null,
};

export const ticConfigDefaultsSlice = createSlice({
  name: 'ticConfigDefaults',
  initialState,
  reducers: {
    setViewingDefaults: (state, action: PayloadAction<boolean>) => {
      state.isViewingDefaults = action.payload;
    },
    clearDefaults: state => {
      state.defaultMemoryConfig = null;
      state.isViewingDefaults = false;
    },
    setDefaultMemoryConfig: (state, action: PayloadAction<MemoryConfig>) => {
      state.defaultMemoryConfig = action.payload;
    },
  },
  selectors: {
    getIsViewingDefaults: state => state.isViewingDefaults,
    getDefaultMemoryConfig: state => state.defaultMemoryConfig,
  },
});

export const { setViewingDefaults, clearDefaults, setDefaultMemoryConfig } =
  ticConfigDefaultsSlice.actions;
export const { getIsViewingDefaults, getDefaultMemoryConfig } = ticConfigDefaultsSlice.selectors;
export default ticConfigDefaultsSlice.reducer;
